import { Status, Wrapper } from "@googlemaps/react-wrapper";
import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import LoadingMask from "./components/LoadingMask/LoadingMask";
import config from "./config/config.json";
import AdminDataSubmissionPage from "./pages/Admin/AdminDataSubmissionPage/AdminDataSubmissionPage";
import AdminPage from "./pages/Admin/AdminPage/AdminPage";
import AdminPlaceEditPage from "./pages/Admin/AdminPlaceEditPage/AdminPlaceEditPage";
import AdminPlacesPage from "./pages/Admin/AdminPlacesPage/AdminPlacesPage";
import AdminUserProfilePage from "./pages/Admin/AdminUserProfilePage/AdminUserProfilePage";
import AdminUsersPage from "./pages/Admin/AdminUsersPage/AdminUsersPage";
import SplashPage from "./pages/SplashPage/SplashPage";
import reportWebVitals from "./utils/reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";
import PublicAppRoutes from "./PublicAppRoutes";
import "./styles/index.scss";

// Configure react-modal for accessibility:
Modal.setAppElement("#root");

const MapsApiKey = config.apiKeys.googlePlaces;

interface AppWithMapsProps {}

const AppWithMaps: React.FC<AppWithMapsProps> = () => {
  const render = (status: Status) => {
    switch (status) {
      case Status.LOADING:
        return <LoadingMask message="Loading Google Maps..." />;
      case Status.FAILURE:
        return (
          <div className="alert alert-danger" role="alert">
            Error loading Google Maps.
          </div>
        );
      case Status.SUCCESS:
        return (
          <>
            <ToastContainer position="bottom-left" />
            <BrowserRouter>
              <Routes>
                {/** ADMIN ROUTES */}
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/users" element={<AdminUsersPage />} />
                <Route
                  path="/admin/user/:userId"
                  element={<AdminUserProfilePage />}
                />
                <Route path="/admin/places" element={<AdminPlacesPage />} />
                <Route
                  path="/admin/places/:placeId"
                  element={<AdminPlaceEditPage />}
                />
                <Route
                  path="/admin/data-submissions"
                  element={<AdminDataSubmissionPage />}
                />
                <Route path="/" element={<SplashPage />} />
                <Route path="*" element={<PublicAppRoutes />} />
              </Routes>
            </BrowserRouter>
          </>
        );
    }
  };

  return (
    <Wrapper
      apiKey={MapsApiKey}
      libraries={["marker", "places"]}
      render={render}
    />
  );
};

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <AppWithMaps />
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}

reportWebVitals(console.log);
